import { render, staticRenderFns } from "./KasaIzbornik.vue?vue&type=template&id=0645d194&scoped=true"
import script from "./KasaIzbornik.vue?vue&type=script&lang=js"
export * from "./KasaIzbornik.vue?vue&type=script&lang=js"
import style0 from "./KasaIzbornik.vue?vue&type=style&index=0&id=0645d194&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0645d194",
  null
  
)

export default component.exports